import { render, staticRenderFns } from "./HasToRegister.vue?vue&type=template&id=5c0cdd3f&scoped=true"
import script from "./HasToRegister.vue?vue&type=script&lang=js"
export * from "./HasToRegister.vue?vue&type=script&lang=js"
import style0 from "./HasToRegister.vue?vue&type=style&index=0&id=5c0cdd3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0cdd3f",
  null
  
)

export default component.exports